import React from 'react';
import './Hero.css';
import profileImage from '../../assets/profile.webp';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1>Mario Monteros</h1>
        <h2>Desarrollador Full Stack y Analista de Datos</h2>
        <p>
          Egresado de Ingeniería en Sistemas (UES), enfocado en construir software útil para negocio.
          Tengo experiencia práctica en desarrollo backend con PHP, creación de dashboards en Power BI y
          parametrización de GLPI para gestión de incidentes. Actualmente me estoy especializando en
          infraestructura cloud para diseñar soluciones escalables, seguras y bien documentadas.
        </p>
        <a href="#projects" className="cta-button">Ver proyectos</a>
      </div>
      <div className="hero-image">
        <div className="photo-placeholder">
          <img
            src={profileImage}
            alt="Foto de perfil de Mario Monteros"
            className="profile-photo"
            width="720"
            height="720"
            fetchPriority="high"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
